export const GlobalLoading = () => {
  return (
    <div className="loading"></div>
  )
}
